import type { FireCMSTranslations } from "@firecms/core";

export const zhTW = {
    save: "儲存",
    create: "建立",
    create_copy: "建立副本",
    save_and_close: "儲存並關閉",
    create_copy_and_close: "建立副本並關閉",
    create_and_close: "建立並關閉",
    discard: "捨棄",
    clear: "清除",
    cancel: "取消",
    edit: "編輯",
    copy: "複製",
    delete: "刪除",
    delete_confirmation_title: "確定刪除？",
    delete_confirmation_body: "這將刪除這筆資料。您確定要繼續嗎？",
    delete_multiple_confirmation_body: "這將刪除所選資料。您確定要繼續嗎？",
    unsaved_changes_title: "尚未儲存的變更",
    unsaved_changes_body: "您有尚未儲存的變更。要捨棄這些變更嗎？",
    discard_changes: "捨棄變更",
    keep_editing: "繼續編輯",
    search: "搜尋",
    find_by_id: "依 ID 尋找",
    find_entity_by_id: "依 ID 尋找資料",
    filter: "篩選",
    filters: "篩選條件",
    clear_filter: "清除篩選條件",
    clear_filter_sort: "清除篩選與排序",
    clear_sort: "清除排序",
    no_items: "沒有項目",
    no_entries_found: "找不到資料",
    all_entries_loaded: "已載入全部 {{count}} 筆資料",
    create_your_first_entry: "建立您的第一筆資料",
    no_results_filter_sort: "沒有符合目前篩選與排序條件的結果",
    add: "新增",
    remove: "移除",
    multiple_entities: "多筆資料",
    unsaved_changes: "您在此{{collectionName}}中有尚未儲存的變更。",
    so_empty: "這裡空空如也……",
    no_results: "沒有符合目前篩選與排序條件的結果",
    refresh_data: "重新整理資料",
    dark_mode: "深色",
    light_mode: "淺色",
    system_mode: "依系統設定",
    ok: "確定",
    save_collection_config: "儲存集合結構",
    search_for_more_icons: "搜尋更多圖示……",
    ai_modified: "已由 AI 修改",
    size_label: "大小",
    group_by: "分組依據",
    initialize_kanban_order: "初始化看板順序",
    copy_id: "複製 ID",
    add_specific: "新增{{name}}",
    select_specific: "選取{{name}}",
    select_from: "從{{name}}選取",
    done: "完成",
    log_out: "登出",
    license_needed: "需要授權",
    license_description: "您需要有效授權才能使用 FireCMS PRO。請透過 {{email}} 聯絡我們，以取得更多資訊。",
    column_cannot_be_edited: "無法直接編輯此欄",
    close: "關閉",
    unsaved_local_changes: "尚未儲存的本機變更",
    unsaved_local_changes_description: "此文件已在本機編輯，且有尚未儲存的變更。若不套用，這些本機變更將會遺失。",
    preview_changes: "預覽變更",
    apply_changes: "套用變更",
    discard_local_changes: "捨棄本機變更",
    preview_local_changes: "預覽本機變更",
    preview_local_changes_description: "以下是將套用至表單的本機變更。",
    type: "類型",
    string: "字串",
    number: "數值",
    boolean: "布林值",
    date: "日期",
    map: "對應表",
    array: "陣列",
    arrays_of_arrays_not_supported: "不支援巢狀陣列。",
    data_type_not_supported: "尚不支援資料類型 {{dataType}}",
    passkey_error_unsupported: "您的裝置或瀏覽器不支援通行金鑰。",
    admin: "管理員",
    home: "首頁",
    this_form_has_errors: "此表單有錯誤",
    error_loading_navigation: "載入導覽時發生錯誤",
    error_loading_auth: "載入驗證資訊時發生錯誤",
    this_form_has_been_modified: "此表單已修改",
    current_form_in_sync: "目前表單已與資料庫同步",
    open_in_console: "在控制台中開啟",
    collection_does_not_exist: "指定的集合不存在。請查看控制台",
    unexpected_value: "非預期的值",
    unexpected_value_click_to_edit: "非預期的值。點選以編輯",
    unexpected_reference_value: "非預期的參照值。點選以編輯",
    copy_url_to_clipboard: "複製網址至剪貼簿",
    open_image_in_new_tab: "在新分頁中開啟圖片",
    reference_not_set: "尚未設定參照",
    reference_does_not_exist: "參照不存在",
    entity_not_found: "找不到資料",
    file_not_found: "找不到檔案",
    unsaved_changes_in_entity: "您在此筆資料中有尚未儲存的變更。",
    delete_this_role: "刪除此角色",
    no_roles_yet: "您尚未建立任何角色。",
    create_default_roles: "建立預設角色",
    delete_role_confirmation: "您確定要刪除此角色嗎？",
    delete_this_user: "刪除此使用者",
    no_users_yet: "尚無使用者",
    add_logged_user_as_admin: "將已登入的使用者新增為管理員",
    add_current_user_as_admin: "將目前使用者新增為管理員",
    create_default_roles_and_add_admin: "建立預設角色，並將目前使用者新增為管理員",
    delete_user_confirmation: "您確定要刪除此使用者嗎？",
    create_your_users_and_roles: "建立您的使用者與角色",
    no_users_or_roles_defined: "您尚未定義使用者或角色。您可以建立預設角色，並將目前使用者新增為管理員。",
    save_before_changing_schema: "變更結構定義前，您需要先儲存文件",
    edit_schema_for_this_form: "編輯此表單的結構定義",
    no_permissions_to_edit_collection: "您沒有編輯此集合的權限",
    browser_does_not_support_audio: "您的瀏覽器不支援音訊元素。",
    user_not_found: "找不到使用者：{{value}}",
    delete_selected: "刪除",
    cannot_delete_selected: "您選取的資料中，至少有一筆無法刪除",
    add_entry: "新增",
    add_on_top: "在最上方新增",
    add_below: "在下方新增",
    add_to_field: "新增至{{fieldName}}",
    value: "值",
    key: "鍵",
    drag_drop_multiple: "將檔案拖放至此處，或點選以選取檔案。拖曳可調整順序。",
    drag_drop_single: "將檔案拖放至此處，或點選以選取檔案",
    open_menu: "開啟選單",
    close_drawer: "關閉側邊欄",
    navigation_drawer: "導覽側邊欄",
    error: "錯誤",
    error_uploading_file: "上傳檔案時發生錯誤",
    error_deleting: "刪除時發生錯誤：{{message}}",
    error_before_delete: "刪除前發生錯誤：{{message}}",
    error_updating_asset: "更新素材時發生錯誤",
    error_deleting_asset: "刪除素材時發生錯誤",
    error_firestore_index: "此查詢需要 Firestore 索引。",
    create_index: "建立索引",
    value_is_not_reference: "此值不是參照。",
    click_to_edit: "點選以編輯",
    data_is_not_array_of_references: "資料不是參照陣列",
    loading: "載入中",
    local_changes_applied: "已將本機變更套用至表單",
    local_changes_discarded: "已捨棄本機變更",
    are_you_sure_leave: "您確定要離開此頁面嗎？",
    see_console_details: "請查看控制台以取得更多詳細資訊。",
    drop_here_create_group: "放開至此處以建立新群組",
    filter_for_null_values: "篩選 null 值",
    value_updated_elsewhere: "此值已在其他地方更新",
    add_property: "新增屬性",
    edit_name: "編輯{{name}}",
    this_entity_not_exist: "此筆資料不存在於資料庫中",
    internal_error: "內部錯誤",
    rename_group: "重新命名群組",
    group_name_label: "群組名稱",
    group_name_empty_error: "群組名稱不能空白。",
    group_name_exists_error: "此群組名稱已存在。",
    search_collections: "搜尋集合",
    views_group: "檢視",
    youd_need_to_save_before_additional_collections: "新增其他集合前，您需要先儲存此筆資料",
    page_not_found: "找不到頁面",
    page_not_found_body: "此頁面不存在，或您沒有存取權限",
    back_to_home: "返回首頁",
    default_collection_view: "預設集合檢視",
    table_view: "表格",
    cards_view: "卡片",
    kanban_view: "看板",
    choose_how_entities_displayed_default: "選擇資料的預設顯示方式",
    document_view: "文件檢視",
    side_panel: "側邊面板",
    full_screen: "全螢幕",
    should_documents_opened_full_screen: "選擇以全螢幕或頁面內的側邊對話框開啟文件",
    select_custom_view: "選取自訂檢視",
    no_custom_views_defined: "尚未定義自訂檢視。使用此對話框前，請先在自訂設定中定義您的自訂檢視。",
    select_custom_action: "選取自訂動作",
    no_custom_actions_defined: "尚未定義自訂動作。使用此對話框前，請先在自訂設定中定義您的自訂動作。",
    no_collections_found: "找不到集合",
    start_building_collections: "輕鬆開始在 FireCMS 中建立集合。您可以將集合對應至現有資料庫的資料、從檔案匯入，或使用我們的範本。",
    create_first_collection: "建立您的第一個集合",
    define_collections_programmatically: "您也可以透過程式碼定義集合。",
    edit_collection: "編輯集合",
    no_permissions_edit_collection: "您沒有編輯此集合的權限",
    no_permissions_create_collection: "您沒有建立集合的權限",
    create_collection: "建立集合",
    update_collection: "更新集合",
    new_collection: "新集合",
    add_new_collection: "新增集合",
    collection_with_name: "{{name}}集合",
    change_icon: "變更圖示",
    is_subcollection_of: "此集合的父集合為",
    name: "名稱",
    collection_name_description: "此集合的名稱，通常使用複數名稱（例如：商品）",
    path: "路徑",
    relative_path_to_parent: "相對於父集合的路徑（不需包含父集合路徑）",
    path_in_database: "此集合儲存在資料庫中的路徑",
    singular_name: "單數名稱",
    singular_name_description: "您可以為資料指定單數名稱（選填）",
    description: "說明",
    description_of_collection: "集合的說明，可使用 Markdown",
    collection_id: "集合 ID",
    collection_id_description: "此 ID 用於識別此集合，通常與路徑相同。",
    collection_group: "集合群組",
    collection_group_description: "集合群組包含所有具有相同路徑的集合，可讓您同時查詢多個集合。",
    advanced_settings: "進階設定",
    doc_history_global: "依全域設定啟用文件歷程記錄",
    doc_history_enabled: "已啟用文件歷程記錄",
    doc_history_not_enabled: "未啟用文件歷程記錄",
    doc_history_description: "啟用後，此集合中的每份文件都會保留變更歷程記錄，可供稽核使用。資料會儲存在資料庫中該文件的 __history 子集合內。",
    document_id_generation: "文件 ID 產生方式",
    code_defined: "由程式碼定義",
    users_must_define_id: "使用者必須指定 ID",
    users_can_define_id: "使用者可以指定 ID，但非必填",
    doc_id_auto_generated: "自動產生文件 ID",
    config_doc_id_generation: "設定建立新資料時產生文件 ID 的方式。",
    enable_text_search: "為此集合啟用文字搜尋",
    text_search_description: "允許搜尋此集合的文字。若未指定文字搜尋委派，將使用內建的本機文字搜尋。不建議對大型集合使用此功能，以免影響效能並增加費用。",
    database_id: "資料庫 ID",
    default_text: "（預設）",
    custom_actions: "自訂動作",
    more_info: "更多資訊",
    define_custom_actions_cli: "透過 CLI 上傳並定義您自己的自訂動作。",
    action_defined_in_code: "此動作已在程式碼中定義，其鍵為",
    add_custom_entity_action: "新增自訂資料動作",
    remove_this_action: "移除此動作？",
    remove_action_warning: "這不會刪除任何資料，只會移除 CMS 中的動作",
    subcollections_of: "以下集合的子集合：",
    add_subcollection: "新增子集合",
    custom_views: "自訂檢視",
    define_custom_views_cli: "透過 CLI 上傳並定義您自己的自訂檢視。",
    view_defined_in_code: "此檢視已在程式碼中定義，其鍵為",
    add_custom_entity_view: "新增自訂資料檢視",
    delete_this_subcollection: "刪除此子集合？",
    remove_collection_warning: "這不會刪除任何資料，只會移除 CMS 中的集合",
    remove_this_view: "移除此檢視？",
    remove_view_warning: "這不會刪除任何資料，只會移除 CMS 中的檢視",
    no_collection_selected: "尚未選取集合",
    code_for_collection: "以下集合的程式碼：",
    use_config_define_json: "使用此設定，以 JSON 格式定義集合。",
    customise_collection_code: "若要透過程式碼自訂集合，您可以將此集合程式碼加入 CMS 應用程式設定中。",
    copied: "已複製",
    property_cant_be_edited: "無法編輯此屬性",
    property_not_editable_description: "您可能沒有編輯權限，或此屬性已在程式碼中定義，且 editable 設為 false。",
    delete_this_property: "刪除此屬性？",
    delete_property_warning: "這不會刪除任何資料，只會修改集合。",
    error_must_specify_id: "您必須指定欄位 ID",
    error_id_format: "ID 只能包含英文字母、數字與底線（_），且不能以數字開頭",
    error_id_already_exists: "已有其他欄位使用此 ID",
    error_must_specify_title: "您必須指定欄位標題",
    custom_or_other: "自訂／其他",
    select_property_widget: "選取屬性控制項",
    error_changing_data_type: "此控制項使用的資料類型與最初選取的控制項不同，可能導致現有資料發生錯誤。",
    required: "必填",
    enum_form_dialog: "列舉值表單對話框",
    imported_data_preview: "匯入資料預覽",
    entities_with_same_id_overwritten: "相同 ID 的資料將被覆寫",
    collection_editor: "集合編輯器",
    properties_in_this_group: "此群組中的屬性",
    data_property_mapping: "資料屬性對應",
    property_edit_view: "屬性編輯檢視",
    all_of_these: "符合以下所有條件",
    any_of_these: "符合以下任一條件",
    only_admins_edit_roles: "只有管理員可以編輯角色",
    error_user_not_found: "找不到使用者",
    role: "角色",
    name_of_this_role: "此角色的名稱",
    id_of_this_role: "此角色的 ID",
    create_entities: "建立資料",
    read_entities: "讀取資料",
    update_entities: "更新資料",
    delete_entities: "刪除資料",
    all_collections: "所有集合",
    create_entities_in_collections: "在集合中建立資料",
    access_all_data_in_every_collection: "存取每個集合中的所有資料",
    update_data_in_any_collection: "更新任意集合中的資料",
    delete_data_in_any_collection: "刪除任意集合中的資料",
    allow_all_permissions_in_this_collections: "允許對這些集合執行所有操作",
    all: "全部",
    customise_permissions_description: "您可以自訂此角色的使用者在各集合資料上可執行的操作權限",
    create_collections: "建立集合",
    yes: "是",
    no: "否",
    can_user_create_collections: "使用者是否可以建立集合",
    edit_collections: "編輯集合",
    only_own_collections: "僅限自己的集合",
    own: "自己的",
    can_user_edit_collections: "使用者是否可以編輯集合",
    delete_collections: "刪除集合",
    can_user_delete_collections: "使用者是否可以刪除集合",
    error_saving_role: "儲存此角色時發生錯誤",
    create_role: "建立角色",
    update: "更新",
    only_admins_change_roles: "只有管理員可以變更角色",
    must_be_at_least_one_admin: "至少必須有一位管理員",
    logged_user_not_found: "找不到已登入的使用者",
    user: "使用者",
    user_id: "使用者 ID",
    name_of_this_user: "此使用者的名稱",
    email_of_this_user: "此使用者的電子郵件地址",
    roles: "角色",
    create_user: "建立使用者",
    users: "使用者",
    add_user: "新增使用者",
    add_role: "新增角色",
    is_admin: "是否為管理員",
    default_permissions: "預設權限",
    created_on: "建立時間",
    email: "電子郵件",
    id: "ID",
    read: "讀取",
    column_in_file: "檔案中的欄",
    map_to_property: "對應至屬性",
    default_values: "預設值",
    default_values_description: "您可以為未對應的欄與空白值選取預設值：",
    property: "屬性",
    default_value: "預設值",
    autogenerate_id: "自動產生 ID",
    id_column_description: "用作每份文件 ID 的欄",
    do_not_set_value: "不設定值",
    set_value_to_true: "將值設為 true",
    set_value_to_false: "將值設為 false",
    drag_and_drop_file: "將檔案拖放至此處，或點選以上傳",
    error_saving_data: "儲存資料時發生錯誤",
    retry: "重試",
    saving_data: "正在儲存資料",
    entities_saved: "筆資料已儲存",
    do_not_close_tab: "請勿關閉此分頁，否則將中斷匯入",
    import: "匯入",
    import_data: "匯入資料",
    upload_file_description: "上傳 CSV、Excel 或 JSON 檔案，並將資料對應至現有的結構定義",
    back: "上一步",
    next: "下一步",
    save_data: "儲存資料",
    use_column_as_id: "使用此欄作為 ID",
    do_not_import_property: "不匯入此屬性",
    entities_will_be_overwritten: "相同 ID 的資料將被覆寫",
    data_imported_successfully: "已成功匯入資料",
    export: "匯出",
    export_data: "匯出資料",
    download_table_csv: "將此表格的內容下載為 CSV 檔案",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "將日期匯出為時間戳記",
    dates_as_strings: "將日期匯出為字串",
    flatten_arrays: "將陣列攤平",
    download: "下載",
    large_number_of_documents: "此集合包含大量文件（{{count}} 份）。",
    include_undefined_values: "包含 undefined 值",
    export_apply_filter_sort: "僅匯出符合目前篩選與排序條件的結果",
    submit: "送出",
    no_filterable_properties: "沒有可供篩選的屬性",
    apply_filters: "套用篩選條件",
    list: "清單",
    cards: "卡片",
    board: "看板",
    initialize_kanban_order_desc: "這將為所有尚未設定順序值的項目依序指派順序值。各欄內的項目將維持目前順序。",
    kanban_view_not_available: "無法使用看板檢視",
    kanban_view_requires_enum: "看板檢視需要具有列舉值的字串屬性，才能將資料分組至各欄。請在集合結構定義中新增列舉屬性，以使用此檢視。",
    no_enum_values_configured: "尚未為屬性「{{property}}」設定列舉值",
    items_need_backfill: "部分項目尚未設定順序值。請先初始化，以啟用拖放排序。",
    initialize: "初始化",
    confirm_multiple_delete: "確定刪除多筆資料？",
    delete_entity_confirm_title: "您要刪除此{{entityName}}嗎？",
    generate_collection_with_ai: "使用 AI 產生集合",
    modify_collection_with_ai: "使用 AI 修改集合",
    describe_collection_to_create: "請描述您想建立的集合。",
    describe_changes_to_make: "請描述您想對此集合進行的變更。",
    ai_placeholder_create: "例如：建立商品集合，包含名稱、價格、說明與分類……",
    ai_placeholder_modify: "例如：新增可儲存圖片的縮圖欄位，將價格設為必填……",
    ai_assist: "AI 輔助",
    generating: "產生中……",
    this_is_subcollection_of: "此集合的父集合為",
    use_existing_paths_database: "使用資料庫中現有的路徑：",
    describe_collection_ai: "向 AI 描述您的集合：",
    generate_with_ai: "使用 AI 產生",
    create_from_json_config: "從 JSON 設定建立：",
    paste_json_config: "貼上 JSON 設定",
    create_collection_from_file_formats: "從檔案建立集合（csv、json、xls、xslx 等）",
    select_template: "選取範本：",
    products: "商品",
    collection_products_subtitle: "包含圖片、價格與庫存的商品集合",
    collection_users_subtitle: "包含電子郵件、名稱與角色的使用者集合",
    blog_posts: "部落格文章",
    collection_blog_posts_subtitle: "包含圖片、作者與複雜內容的部落格文章集合",
    pages: "頁面",
    collection_pages_subtitle: "包含圖片、作者與複雜內容的頁面集合",
    continue_from_scratch: "從零開始",
    cms_users: "CMS 使用者",
    roles_menu: "角色",
    project_settings: "專案設定",
    firestore_manager: "Firestore 管理工具",
    manage_your_firestore_data: "管理您的 Firestore 資料",
    build_admin_panel_in_minutes: "幾分鐘內打造您的 Firebase 管理後台",
    go_live_instantly: "立即上線：",
    create_production_ready_back_offices: "建立可用於正式環境的管理後台，",
    without_the_frontend_hassle: "無須煩惱前端開發。",
    automatic_setup: "自動設定，",
    from_your_existing_firestore_data: "直接使用您現有的 Firestore 資料。",
    seamless_real_time_firebase_integration: "無縫整合 Firebase，即時同步資料。",
    intuitive_spreadsheet_like_ui: "直覺的試算表式介面，",
    your_whole_team_can_use: "全體團隊成員都能輕鬆使用。",
    focus_on_your_app: "專注於您的應用程式，",
    not_the_admin_panel: "而非管理後台。",
    join_our_newsletter: "訂閱我們的電子報。不寄垃圾郵件，只提供重要更新！",
    by_signing_in_you_agree_to_our: "登入即表示您同意我們的",
    terms_and_conditions: "條款與細則",
    and_our: "以及我們的",
    privacy_policy: "隱私權政策",
    firecms_cloud_google_disclosure: "FireCMS Cloud 使用從 Google API 取得的資訊，或將資訊傳送至其他應用程式時，均遵循",
    google_api_services_user_data_policy: "Google API 服務使用者資料政策",
    including_the_limited_use_requirements: "，包括限制使用規定。",
    email_password: "電子郵件／密碼",
    sign_in_with_google: "使用 Google 帳號登入",
    auth_user_not_found: "找不到使用者",
    auth_wrong_password: "密碼錯誤，請再試一次。",
    auth_user_disabled: "此使用者已停用，請聯絡支援人員。",
    auth_account_exists_with_different_credential: "此帳號已使用其他登入方式註冊",
    auth_email_already_in_use: "此電子郵件地址已被使用",
    auth_google_permissions_required: "您需要授予額外權限，才能管理您的 Google Cloud 專案",
    auth_invalid_email_password: "請輸入電子郵件地址與密碼",
    auth_enter_email_first: "請先輸入您的電子郵件地址",
    auth_password_reset_sent: "已寄送密碼重設郵件",
    auth_sign_in_account: "登入您的帳號",
    auth_create_new_account: "建立新帳號",
    auth_password: "密碼",
    auth_reset_password: "重設密碼",
    auth_new_user: "新使用者？",
    auth_have_account: "已有帳號？",
    auth_sign_in: "登入",
    auth_sign_up: "註冊",
    subscriptions: "訂閱",
    manage_your_subscriptions_in_stripe: "在 Stripe 中管理您的訂閱",
    go_to_your_stripe_portal: "前往您的 Stripe 使用者入口網站查看帳單記錄。您也可以在此管理與已登入使用者相關聯的訂閱。",
    your_pro_licenses: "您的 PRO 授權",
    create_new_license: "建立新授權",
    create_subscriptions_in_this_section: "此區僅供自行託管的 FireCMS PRO 建立訂閱。若您使用 FireCMS Cloud，請在專案設定中升級您的專案。",
    if_you_are_an_agency: "若您是代理商，可以將您的授權轉售給客戶。",
    if_you_have_any_questions: "若您有任何問題或需要協助，請透過以下方式聯絡我們：",
    you_have_not_created_any_pro_licenses: "您尚未建立任何 FireCMS PRO 授權",
    archive: "封存",
    licensed_projects_lowercase: "已授權專案",
    manage: "管理",
    update_payment_method: "更新付款方式",
    your_firecms_cloud_projects: "您的 FireCMS Cloud 專案",
    status_active: "使用中",
    status_trialing: "試用中",
    status_past_due: "付款逾期",
    status_canceled: "已取消",
    status_unpaid: "尚未付款",
    status_incomplete: "尚未完成",
    status_incomplete_expired: "未完成且已到期",
    status_unknown: "未知",
    plan_free: "未訂閱",
    plan_cloud_plus: "已訂閱",
    plan_pro: "Pro",
    plan_unknown: "未知方案",
    auto_setup_collections_button: "自動設定集合",
    auto_setup_collections_title: "自動設定集合？",
    auto_setup_collections_desc: "這將為<b>尚未</b>對應的集合自動建立集合設定",
    setting_up_collections: "正在設定集合",
    setting_up_collection: "正在設定{{name}}",
    no_collections_found_to_setup: "找不到可設定的集合。",
    collections_have_been_setup: "已自動完成集合設定。",
    error_setting_up_collections: "自動設定集合時發生錯誤",
    setup_collections_title: "設定集合",
    setup_collections_select_desc: "選取要自動設定的集合：",
    select_all: "全選",
    deselect_all: "取消全選",
    setup_collections_confirm: "設定（{{count}}）",
    collection_setup_success: "已完成{{name}}的設定",
    go_to_collection: "前往集合",
    add_your: "新增您的",
    database_collections: "資料庫集合",
    to_firecms: "至 FireCMS",
    no_unmapped_collections: "資料庫中沒有尚未對應的集合",
    query_and_update_with_datatalk: "透過以下工具，以自然語言查詢與更新您的資料：",
    welcome_to_firecms: "歡迎使用 FireCMS Cloud",
    admin_panel_ready_bring_data: "您的管理後台已準備就緒。現在就匯入您的資料吧。",
    admin_panel_ready_get_started: "您的管理後台已準備就緒。以下是開始使用的方式。",
    auto_detect_collections: "自動偵測集合",
    auto_detect_collections_desc: "讓 AI 掃描您的資料庫，並自動產生集合結構定義。",
    create_a_collection: "建立集合",
    create_collection_desc: "使用視覺化編輯器，從零開始手動定義您的第一個集合。",
    read_the_docs: "閱讀文件",
    read_the_docs_desc: "瞭解如何自訂欄位、檢視、動作等功能。",
    explore_docs: "瀏覽文件",
    want_to_customize_with_code: "想透過程式碼自訂嗎？請執行",
    to_scaffold_a_local_project: "以產生本機專案骨架。",
    validation: "驗證",
    unique: "不重複",
    required_message: "必填提示訊息",
    required_tooltip: "若未設定此值，您將無法儲存此筆資料",
    unique_tooltip: "不可有多筆資料使用相同的值",
    lowercase: "小寫",
    uppercase: "大寫",
    trim: "移除首尾空白",
    exact_length: "固定長度",
    min_length: "最短長度",
    max_length: "最長長度",
    matches_regex: "符合正規表示式",
    not_valid_regexp: "無效的正規表示式",
    regex_helper: "例如：/^\\d+$/ 表示僅允許數字",
    min_value: "最小值",
    max_value: "最大值",
    less_than: "小於",
    more_than: "大於",
    positive_value: "正數",
    negative_value: "負數",
    integer_value: "整數",
    invalid_regular_expression: "無效的正規表示式",
    must_specify_target_collection: "您必須為此欄位指定目標集合",
    need_specify_repeat_field: "您需要指定重複欄位",
    need_specify_block_properties: "您需要指定此區塊的屬性",
    incomplete_condition: "條件不完整，請選取欄位",
    field_name: "欄位名稱",
    kanban_column_property: "看板分欄屬性",
    select_a_property: "選取屬性",
    kanban_property_not_found: "屬性「{{property}}」不存在，或不是列舉字串屬性。請選取有效的屬性，或清除選取項目。",
    no_enum_string_properties: "找不到列舉字串屬性。請新增具有 enumValues 的字串屬性，以使用看板檢視。",
    kanban_column_description: "選取具有列舉值的字串屬性，將資料分組至各欄",
    create_property: "+ 建立「{{property}}」屬性",
    order_property: "排序屬性",
    order_property_not_found: "屬性「{{property}}」不存在，或不是數值屬性。請選取有效的屬性，或清除選取項目。",
    no_number_properties: "找不到數值屬性。請新增數值屬性以啟用排序。",
    order_property_description: "選取數值屬性，用於儲存項目順序",
    image_property: "圖片屬性",
    image_property_not_found: "屬性「{{property}}」不存在，或不是圖片屬性。請選取有效的屬性，或清除選取項目。",
    no_image_properties: "找不到圖片屬性。請新增儲存空間或 URL 圖片屬性，作為縮圖使用。",
    image_property_description: "選取卡片與看板檢視模式中用作縮圖的屬性。若未設定，將自動使用第一個符合條件的圖片屬性。",
    display_settings: "顯示設定",
    default_row_size: "預設列大小",
    side_dialog_width: "側邊對話框寬度",
    side_dialog_width_description: "您可以設定資料側邊對話框的寬度（以像素為單位）。預設為 768px",
    inline_editing_enabled: "可直接在表格檢視中編輯資料",
    inline_editing_disabled: "僅可在表單檢視中編輯資料",
    inline_editing_description: "允許直接在表格檢視中編輯資料，無須開啟表單檢視。",
    include_json_view: "包含 JSON 檢視",
    no_json_view: "不包含 JSON 檢視",
    json_view_description: "包含文件的 JSON 表示方式。",
    not_found_suffix: "找不到",
    editor_text: "文字",
    editor_text_description: "直接開始輸入純文字。",
    editor_heading_1: "標題 1",
    editor_heading_1_description: "大型段落標題。",
    editor_heading_2: "標題 2",
    editor_heading_2_description: "中型段落標題。",
    editor_heading_3: "標題 3",
    editor_heading_3_description: "小型段落標題。",
    editor_todo_list: "待辦清單",
    editor_todo_list_description: "使用待辦清單追蹤工作。",
    editor_bullet_list: "項目符號清單",
    editor_bullet_list_description: "建立簡單的項目符號清單。",
    editor_numbered_list: "編號清單",
    editor_numbered_list_description: "建立含編號的清單。",
    editor_quote: "引文",
    editor_quote_description: "加入引文。",
    editor_code: "程式碼",
    editor_code_description: "加入程式碼片段。",
    editor_image: "圖片",
    editor_image_description: "從您的電腦上傳圖片。",
    editor_multiple: "多個",
    editor_link: "連結",
    editor_save: "儲存",
    editor_cancel: "取消",
    editor_remove_link: "移除連結",
    editor_paste_or_type_link: "貼上或輸入連結",
    editor_open_in_new_window: "在新視窗中開啟",
    editor_bold: "粗體",
    editor_italic: "斜體",
    editor_underline: "底線",
    editor_strikethrough: "刪除線",
    editor_autocomplete: "自動完成",
    editor_autocomplete_description: "根據上下文新增文字。",
    text_search_dialog_title: "啟用文字搜尋",
    text_search_local_not_recommended: "不建議對大型集合使用本機文字搜尋。",
    text_search_local_fetch_warning: "請注意，啟用本機文字搜尋後，系統需要擷取集合中的所有文件，並儲存在瀏覽器中。對大型集合而言，這可能效率不佳，也可能產生額外費用。",
    text_search_external_suggestion: "對於較大的集合，建議使用 Algolia 或 Elastic Search 等外部搜尋引擎，並在設定中指定搜尋委派。",
    text_search_local_description: "本機文字搜尋是在集合中啟用文字搜尋最簡單的方式。系統會將集合中的所有文件載入瀏覽器，並在本機執行搜尋。這是小型集合的建議選項。",
    text_search_own_implementation: "您已實作自己的文字搜尋控制器，可為集合啟用文字搜尋。",
    text_search_enable_for_collection: "為此集合啟用",
    text_search_enable_for_project: "為專案啟用",
    text_search_enabled_snackbar: "已啟用本機文字搜尋",
    settings_subscription_plan: "訂閱方案",
    settings_subscribed_to: "您目前訂閱的方案為",
    settings_no_active_subscription: "此專案目前沒有有效的訂閱。",
    settings_trial_valid_until: "您的試用期限至 {{date}}。",
    settings_features_intro: "以下是您使用 FireCMS Cloud 已享有的部分功能",
    settings_feature_managed_service: "持續保持最新的代管服務",
    settings_feature_local_text_search: "本機文字搜尋",
    settings_feature_unlimited_users_roles: "不限數量的使用者與角色",
    settings_feature_theme_logo: "自訂主題與標誌",
    settings_feature_custom_fields_views: "自訂表單欄位與檢視",
    settings_feature_secondary_databases: "次要資料庫",
    settings_feature_ai_content: "透過 OpenAI 與 Google 產生 AI 內容",
    settings_feature_unlimited_export: "不限次數的資料匯出",
    settings_feature_appcheck: "AppCheck",
    settings_heading: "設定",
    settings_project_name: "專案名稱",
    settings_default_language: "預設語言",
    settings_default_language_caption: "選取此專案的基礎語言。使用者可以在個人設定中變更此偏好。",
    settings_enable_local_text_search: "啟用本機文字搜尋",
    settings_local_text_search_caption: "為所有集合啟用本機文字搜尋。您將能使用 FireCMS 搜尋列，搜尋集合中的文字欄位。請注意，此功能會為集合中的所有文字欄位建立索引，可能增加讀取次數。",
    settings_doc_history_all_collections: "為所有集合啟用文件歷程記錄",
    settings_doc_history_caption: "啟用時，所有集合預設都會保留歷程記錄。您可以在各集合中覆寫此設定。歷程記錄將儲存在每份文件的 __history 子集合中。",
    settings_theme: "主題",
    settings_primary_color: "主要色彩",
    settings_secondary_color: "次要色彩",
    settings_sample_theme_components: "主題元件範例",
    settings_drag_drop_logo: "將您的標誌拖放至此處",
    settings_create_subscription: "建立訂閱",
    settings_stripe_disclaimer: "您將被導向 Stripe 完成訂閱。費用依當月最高使用者人數按月計算。您可隨時取消；由於目前計費期間的費用已支付，取消後不會再收取額外費用。",
    settings_subscription_is: "訂閱狀態為",
    settings_next_payment_on: "下次付款日期為 {{date}}。",
    settings_seats_count: "您擁有",
    settings_seat: "個席次",
    settings_seats: "個席次",
    settings_per_seat: "每席次／{{interval}} 為 {{price}}",
    settings_current_price: "目前價格為",
    settings_per_user_usage: "每位使用者（依用量計費）。",
    settings_cancelled_active_until: "此訂閱已取消，有效期限至 {{date}}。",
    settings_no_additional_charges: "取消後不會再收取額外費用。",
    settings_manage_subscription: "管理訂閱",
    settings_security_rules: "安全性規則",
    settings_security_rules_description: "FireCMS 使用 Firebase 安全性規則限制資料存取。透過 FireCMS 建立新使用者時，會在客戶專案中為該使用者新增 fireCMSUser 自訂宣告。將以下安全性規則加入您的專案，即可確保 FireCMS 使用者能透過 FireCMS 存取資料。",
    settings_security_rules_add_domain: "請記得將網域 {{domain}} 加入供應商允許的網域清單",
    settings_security_rules_caption: "這些規則僅允許 FireCMS 使用者存取資料，但不會在資料庫層級強制執行權限限制。權限限制會在前端執行，適用於大多數專案。若您需要在資料庫層級強制執行權限限制，可以自行修改這些安全性規則，以符合需求。指派給使用者的角色會以自訂宣告的形式儲存在 Firebase 驗證權杖中，因此您可以在安全性規則中使用這些角色。",
    settings_appcheck: "AppCheck",
    settings_appcheck_description: "您可以啟用 AppCheck，保護您的 Firebase 服務免遭濫用。請參閱 Firebase 文件瞭解設定方式。設定好供應商後，即可在此啟用。您需要在 Firebase 專案設定中提供密鑰，並在 FireCMS 設定中提供網站金鑰。",
    settings_appcheck_add_domain: "請記得將網域 {{domain}} 加入供應商允許的網域清單",
    settings_appcheck_enable: "啟用 AppCheck",
    settings_appcheck_site_key: "網站金鑰",
    settings_appcheck_update: "更新 AppCheck",
    settings_appcheck_refresh_note: "儲存後，您可能需要重新整理頁面才能看到變更。",
    settings_appcheck_updated: "已更新 AppCheck",
    settings_appcheck_error: "更新 AppCheck 時發生錯誤",
    missing_firestore_security_rules: "缺少 Firestore 安全性規則",
    firecms_cloud_requires_security_rule: "FireCMS Cloud 需要在您的 Firestore 中設定特定安全性規則，才能授予已驗證使用者存取權限。若未設定此規則，集合",
    cannot_be_accessed_without_it: "將無法存取。",
    required_security_rule: "必要的安全性規則",
    fix_automatically: "自動修正",
    open_firebase_rules: "開啟 Firebase 規則",
    security_rules_updated_successfully: "已成功更新安全性規則！請重新整理頁面以載入您的資料。",
    sec_rules_fixing: "修正中……",
    sec_rules_fixed: "已修正！",
    marketplace_managed_by_gcp: "透過 GCP Marketplace 管理",
    marketplace_billing_note: "您的訂閱由 Google Cloud Marketplace 管理。方案變更、帳務與取消訂閱皆透過 GCP 控制台處理。",
    marketplace_manage_in_gcp_console: "在 GCP 控制台中管理",
    marketplace_plan_changes_note: "如需變更方案或取消訂閱，請前往您的 GCP Marketplace 訂單。",
    marketplace_welcome_title: "歡迎來自 GCP Marketplace 的使用者！",
    marketplace_welcome_subtitle: "您的 Google Cloud Marketplace 訂閱已生效。請選取現有專案，或建立新專案以進行連結。",
    marketplace_select_or_create_project: "選取或建立專案",
    marketplace_link_project: "連結專案",
    marketplace_linking: "正在連結專案……",
    marketplace_link_success: "已成功連結專案！正在重新導向……",
    marketplace_link_error: "連結專案時發生錯誤，請再試一次。",
    marketplace_no_account_id: "找不到 GCP Marketplace 帳號 ID。請從 GCP Marketplace 開始操作。",
} satisfies FireCMSTranslations;
